import * as React from "react"
const SvgDatabase = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 21.286q-3.775 0-6.388-1.163Q3 18.961 3 17.286v-10q0-1.65 2.638-2.825T12 3.286c3.725 0 4.604.391 6.363 1.175Q20.999 5.636 21 7.286v10q0 1.674-2.613 2.837-2.611 1.163-6.387 1.163M12 9.31q2.225 0 4.475-.638Q18.725 8.035 19 7.31q-.274-.726-2.512-1.375a15.87 15.87 0 0 0-8.95-.013Q5.348 6.561 5 7.311q.35.75 2.537 1.375 2.188.625 4.463.625Zm0 4.975q1.05 0 2.025-.1t1.862-.288a14 14 0 0 0 1.675-.462A10 10 0 0 0 19 12.81v-3a10 10 0 0 1-1.438.625 14 14 0 0 1-1.675.462q-.887.188-1.862.288a20.6 20.6 0 0 1-4.075 0 18 18 0 0 1-1.887-.288 13 13 0 0 1-1.663-.462A9 9 0 0 1 5 9.81v3q.625.35 1.4.625.775.274 1.662.462.888.188 1.888.288t2.05.1m0 5q1.15 0 2.338-.175 1.186-.175 2.187-.463 1-.287 1.675-.65.675-.362.8-.737v-2.45a10 10 0 0 1-1.438.625 14 14 0 0 1-1.675.462q-.887.187-1.862.288a20.6 20.6 0 0 1-4.075 0 18 18 0 0 1-1.887-.288 13 13 0 0 1-1.663-.462A9 9 0 0 1 5 14.81v2.475q.125.375.787.725.663.35 1.663.637t2.2.463q1.2.175 2.35.175" />
  </svg>
)
export default SvgDatabase
